import { CardInputWithType, ECardType, LinkInput } from '__generated__/globalTypes';
import { CreateGuideStoryVariables } from 'graphql/mutation/__generated__/CreateGuideStory';
import { GuideQuery_guide_stories } from 'graphql/query/__generated__/GuideQuery';
import { uniq } from 'lodash';

const CATEGORIES = {
    elektro: '2103acc0-2a6e-4f57-8cdb-4d0640fa8015',
    'energetika a tepelná technika': '20d2c6a9-c2cc-4463-bc1a-65205288efe1',
    'informační technologie': 'a076df95-fd60-4a03-bcf1-c79ef19ec12b',
    'robotika a automatizace': '4b337c52-b321-46a7-8c24-922d631d2ebb',
    'ekonomika, podnikové finance a bankovnictví': 'dbddc8c6-fcb2-4d6f-ac01-4f712e42e891',
    ekonomika: 'dbddc8c6-fcb2-4d6f-ac01-4f712e42e891',
    'podnikové finance a bankovnictví': 'dbddc8c6-fcb2-4d6f-ac01-4f712e42e891',
    kvalita: '7836e860-5196-4020-86fe-a3a372c1f8d9',
    'doprava, logistika a bezpečnost': 'ab1a47b8-4009-4701-96eb-86efa7f0fdeb',
    'logistika a bezpečnost': 'ab1a47b8-4009-4701-96eb-86efa7f0fdeb',
    doprava: 'ab1a47b8-4009-4701-96eb-86efa7f0fdeb',
    strojírenství: '7abb6858-2d70-4034-990f-af23e6a450c3',
    automotiv: '23c2115a-315c-41a8-bcb0-bb6f925947df',
    'stavebnictví a architektura': '742d7dd2-3bfe-46f7-8a5c-839f7df78470',
    'materiály a chemie': '09bbe5f4-fb5b-41ed-b551-66ef96a825e8',
    administrativa: '202e9837-df3e-4332-85bc-02c197022ee9',
    obchod: '77662202-01c0-46e4-9f4b-f2307e5eb51f',
    'služby a klientský servis': '4ac5afdc-13bb-4cc6-98be-6a22ace3db88',
    'marketing a média': 'eabfc76c-9fdb-4e85-be4a-47e8a4f75f49',
    'geo a enviro': '993cd73b-8485-49bc-a6c4-e65d4198a10e',
    'lidské zdroje a management': 'f51f8e97-cce7-4fc2-bc07-04c5674779a3',
    pohony: 'f9011d49-74ef-4458-be51-89c071c35bfe',
    vývoj: 'fd0d8340-e3f2-48ad-95c6-611f8ee9dc1e',
    telekomunikace: '58cf76d8-9b73-48bf-a47c-f6161029af82',
    letectví: 'c6e45fd1-6bec-4ee6-baa6-7836b3c57026'
};

const CATEGORY_FOREIGN_WELCOME = '8c88baba-f916-41f6-a422-a8848fefeaad';

function parser(guideId: string, row: Record<string, string>): CreateGuideStoryVariables {
    const mutationPayload: CreateGuideStoryVariables = {
        guideId,
        story: {
            importKey: row['Váš email'],
            header: {
                title: row['Název společnosti pro zveřejnění na webu veletrhu.'],
                text: row['Představení společnosti']
                // imageUrl: row['img'],
                // imageStyleId: 'stretch'
            }
        },
        cards: []
    };

    // const hasContactCard = row['Kontaktní telefon'] || row['Kontaktní e-mail'];
    // const contactCard: CardInputWithType = {
    //     type: ECardType.TEXT,
    //     info: {
    //         title: 'Kontakt',
    //         description: (() => {
    //             let text = '';

    //             if (row['Kontaktní telefon']) {
    //                 text += `**Telefon:** ${row['Kontaktní telefon'].trim()}\n`;
    //             }

    //             if (row['Kontaktní e-mail']) {
    //                 text += `**Email:** ${row['Kontaktní e-mail'].trim()}\n`;
    //             }

    //             return text;
    //         })()
    //     }
    // };

    const hasLinkCard = row['Web společnosti'];
    const linkCard: CardInputWithType = {
        type: ECardType.LINK,
        links: (() => {
            const links: LinkInput[] = [];
            if (row['Web společnosti']) {
                links.push({
                    title: 'Web společnosti',
                    url: row['Web společnosti']
                });
            }
            return links;
        })()
    };

    // if (hasContactCard) {
    //     mutationPayload.cards.push(contactCard);
    // }
    if (hasLinkCard) {
        mutationPayload.cards.push(linkCard);
    }

    const categories: string[] = [];

    if (row['Nabízíte zaměstnání pro anglicky mluvící cizince?']?.toLowerCase() === 'ano') {
        categories.push(CATEGORY_FOREIGN_WELCOME);
    }

    const obory = row['Hlavní obory, ve kterých hledáte uchazeče']
        ?.toLowerCase()
        .split(',')
        .map((e) => e.trim());
    for (const obor of obory) {
        if (CATEGORIES[obor]) {
            categories.push(CATEGORIES[obor]);
        }
    }

    mutationPayload.addToCategoriesId = uniq(categories);

    return mutationPayload;
}

function duplicateChecker(story: GuideQuery_guide_stories, row: Record<string, string>): boolean {
    return story.importKey?.toLowerCase() === row['Váš email']?.toLowerCase();
}

export const vsbImportMethods = { duplicateChecker, parser };
